module.exports = __webpack_public_path__ + "logo_moc_bilja_josif_pancic.png?c0feacf31c8d2636f49dd94f532c21f8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/logo_moc_bilja_josif_pancic.png
// module id = 77
// module chunks = 0